import { render, staticRenderFns } from "./proComThre.vue?vue&type=template&id=5ff4dffe&scoped=true&"
import script from "./proComThre.vue?vue&type=script&lang=js&"
export * from "./proComThre.vue?vue&type=script&lang=js&"
import style0 from "./proComThre.vue?vue&type=style&index=0&id=5ff4dffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff4dffe",
  null
  
)

export default component.exports